export const categories = [
  {
    slug: 'life-experience',
    name: '人生经历',
    description: '从童年到成名，再到最终的告别，饭岛爱波澜壮阔的一生',
    icon: 'ri-user-heart-line',
    color: 'accent',
  },
  {
    slug: 'works',
    name: '代表作品',
    description: '文学作品、影视作品及综艺节目等代表作全收录',
    icon: 'ri-book-open-line',
    color: 'primary',
  },
  {
    slug: 'social-impact',
    name: '社会影响',
    description: '饭岛爱对日本社会、女性议题及文化的深远影响',
    icon: 'ri-global-line',
    color: 'secondary',
  },
  {
    slug: 'media',
    name: '媒体报道',
    description: '各大媒体对饭岛爱的专访、报道与评论',
    icon: 'ri-newspaper-line',
    color: 'accent',
  },
  {
    slug: 'memorial',
    name: '纪念文章',
    description: '粉丝、友人与同行撰写的追忆与纪念文章',
    icon: 'ri-heart-2-line',
    color: 'primary',
  },
];

export const articles = [
  {
    id: 1,
    title: '饭岛爱：从普通女孩到日本最具话题性的女性',
    slug: 'from-ordinary-girl-to-icon',
    category: 'life-experience',
    excerpt: '1972年出生于东京都的饭岛爱，原名大久保松惠。她的成长经历充满坎坷——家庭不和、校园欺凌、离家出走，这些早年的创伤塑造了她复杂而敏感的内心世界，也为她日后的人生轨迹埋下了伏笔。',
    content: `饭岛爱，1972年10月31日出生于日本东京都，原名大久保松惠。她的童年并不幸福，父母的严格管教与家庭的不和谐让她从小就缺乏安全感。

中学时期，饭岛爱遭受了严重的校园欺凌，这成为她人生中难以抹去的阴影。为了逃避现实，她开始频繁离家出走，最终在高中时期彻底离开了家庭。

在东京的街头，年轻的饭岛爱经历了常人难以想象的艰难岁月。她曾在便利店打工，也曾流落街头。命运的转折发生在她被星探发掘之后——她以"饭岛爱"的艺名进入了成人影片行业。

然而，饭岛爱从未将自己局限于此。她凭借出众的才华和坚韧的意志，逐步转型为电视艺人和作家，在日本主流娱乐圈站稳了脚跟。她的自传《柏拉图式性爱》更是成为日本出版史上的现象级作品，销量突破百万册。

饭岛爱的一生，是苦难与辉煌交织的一生。她用自己的经历告诉世人：无论出身如何，无论经历过什么，都有可能通过自己的努力改写命运。`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20silhouette%20standing%20under%20soft%20cherry%20blossom%20trees%20at%20sunset%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20light%2C%20contemplative%20mood%2C%20artistic%20photography%20style%2C%20minimalist%20composition%2C%20cream%20and%20rose%20tones&width=800&height=500&seq=iijima-life-01&orientation=landscape',
    date: '2024-03-15',
    author: '编辑团队',
    tags: ['饭岛爱', '人生经历', '日本娱乐圈'],
    featured: true,
  },
  {
    id: 2,
    title: '《柏拉图式性爱》：一本改变日本社会的自白书',
    slug: 'platonic-sex-book',
    category: 'works',
    excerpt: '2000年出版的《柏拉图式性爱》是饭岛爱的半自传体小说，书中坦诚记录了她从少女时代到成为AV女优的心路历程，在日本社会引起巨大轰动，销量超过170万册。',
    content: `2000年10月，饭岛爱出版了她的半自传体小说《柏拉图式性爱》（プラトニック・セックス）。这本书一经出版，便在日本社会掀起了轩然大波。

书中，饭岛爱以惊人的坦诚记录了自己的人生轨迹：从不幸的童年、校园欺凌、离家出走，到进入成人影片行业，再到后来的转型与重生。她毫不避讳地描写了少女时代的痛苦、迷茫与挣扎，字里行间流露出对爱与被爱的深切渴望。

《柏拉图式性爱》的书名本身就充满了深意。柏拉图式的爱，是纯粹精神层面的爱，是不涉及肉体的爱。而饭岛爱本人却恰恰因为"肉体"而被世人所知。这种反差与悖论，正是她想要表达的：她渴望的从来不是肉体的欢愉，而是真正的理解、尊重与爱。

这本书在日本销量突破170万册，成为当年的畅销书榜首。它不仅是一部个人传记，更是一面映照日本社会问题的镜子——校园欺凌、家庭暴力、青少年性教育缺失、女性在社会中的困境……饭岛爱用自己赤裸裸的经历，逼着日本社会直面这些长久以来被忽视的问题。

2001年，《柏拉图式性爱》被改编为电视剧和电影，进一步扩大了其社会影响力。时至今日，这本书仍然被视为日本现代文学中不可忽视的重要作品。`,
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20elegant%20Japanese%20books%20on%20a%20wooden%20desk%20with%20soft%20natural%20lighting%2C%20one%20book%20open%2C%20cherry%20blossom%20petals%20scattered%2C%20warm%20cream%20tones%2C%20literary%20atmosphere%2C%20minimalist%20aesthetic&width=800&height=500&seq=iijima-book-01&orientation=landscape',
    date: '2024-02-28',
    author: '编辑团队',
    tags: ['饭岛爱', '柏拉图式性爱', '自传', '畅销书'],
    featured: true,
  },
  {
    id: 3,
    title: '从AV女优到电视明星：饭岛爱的华丽转身',
    slug: 'from-av-to-tv-star',
    category: 'life-experience',
    excerpt: '饭岛爱成功从成人影片行业转型为日本主流综艺节目的常驻嘉宾，这一罕见的职业转型之路展现了她的智慧与韧性，也为后来者树立了榜样。',
    content: `在日本娱乐圈，从AV行业成功转型到主流媒体的例子屈指可数，而饭岛爱无疑是其中最成功的一位。

1990年代初期，饭岛爱凭借在成人影片行业的知名度开始获得电视节目的邀约。但她并没有满足于做一个"话题人物"，而是以惊人的学习能力和职业素养，迅速掌握了综艺节目所需的各项技能——机智的应对、恰到好处的幽默感、以及在节目中展现真实自我的勇气。

她先后成为多个日本热门综艺节目的常驻嘉宾，包括富士电视台的《笑笑也无妨！》、朝日电视台的《伦敦之心》等。在这些节目中，饭岛爱展现了与AV女优形象截然不同的一面——聪明、幽默、善解人意，并且有着令人惊讶的洞察力。

她的转型成功绝非偶然。饭岛爱在节目中从不回避自己的过去，反而以坦诚的态度赢得了观众的尊重。她曾说："我不为我的过去感到羞耻，因为正是那些经历塑造了今天的我。"这种直面过去的勇气，让她成为了许多日本女性心目中的榜样。

饭岛爱的成功转型，打破了日本社会对AV女优的刻板印象，也为后来试图转型的同行们开辟了道路。她的经历证明：一个人的价值，不应该被某一段经历所定义。`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20TV%20studio%20set%20with%20soft%20warm%20lighting%2C%20modern%20broadcast%20environment%2C%20professional%20atmosphere%2C%20cream%20and%20gold%20tones%2C%20minimalist%20Japanese%20aesthetic&width=800&height=500&seq=iijima-tv-01&orientation=landscape',
    date: '2024-02-10',
    author: '编辑团队',
    tags: ['饭岛爱', '综艺节目', '职业转型', '日本电视'],
    featured: true,
  },
  {
    id: 4,
    title: '饭岛爱的离去：一代传奇的终章',
    slug: 'the-final-chapter',
    category: 'life-experience',
    excerpt: '2008年12月24日，饭岛爱被发现于东京家中去世，年仅36岁。她的突然离世震惊了整个日本，也让无数粉丝陷入深深的悲痛。',
    content: `2008年12月24日，圣诞节前夕，一个令人心碎的消息传遍了日本——饭岛爱被发现于东京都涩谷区的家中去世，年仅36岁。

消息传出后，日本各大媒体纷纷中断正常节目，插播这一震惊的消息。社交媒体上，无数粉丝表达了难以置信的悲痛。许多曾与饭岛爱共事的艺人也在节目中落泪，回忆与她相处的点点滴滴。

饭岛爱的离世引发了日本社会对心理健康问题的广泛讨论。她生前曾在多个场合坦诚自己与抑郁症的斗争，但当时的日本社会对心理健康的重视程度远不如今天。她的离去，也成为了推动日本社会正视心理健康问题的一个契机。

在饭岛爱的葬礼上，众多粉丝自发前来送别。她的一生虽然短暂，却留下了不可磨灭的印记——她的书、她的节目、她的言论、她的勇气，都在继续影响着后来的人们。

正如她自己在《柏拉图式性爱》中写道的："人生就像一场旅行，重要的不是目的地，而是沿途的风景和看风景的心情。"饭岛爱的旅程虽然提前结束了，但她留下的风景，将永远留在爱她的人们心中。`,
    image: 'https://readdy.ai/api/search-image?query=Single%20white%20lily%20flower%20on%20a%20minimalist%20dark%20surface%2C%20soft%20dramatic%20lighting%20from%20above%2C%20elegant%20and%20solemn%20atmosphere%2C%20cream%20and%20shadow%20tones%2C%20fine%20art%20photography&width=800&height=500&seq=iijima-memorial-01&orientation=landscape',
    date: '2024-01-20',
    author: '编辑团队',
    tags: ['饭岛爱', '逝世', '追忆', '日本社会'],
    featured: false,
  },
  {
    id: 5,
    title: '饭岛爱对日本女性议题的深远影响',
    slug: 'impact-on-women-issues',
    category: 'social-impact',
    excerpt: '饭岛爱通过自己的经历和发声，推动了日本社会对女性权益、性别平等和性教育等议题的关注与讨论，她的影响力远超娱乐圈范畴。',
    content: `饭岛爱的影响力远不止于娱乐圈。她通过自己的经历和公开发声，对日本社会的多个重要议题产生了深远影响。

在女性权益方面，饭岛爱是日本少数敢于公开讨论女性身体自主权的公众人物之一。她曾在多个场合表示，女性应该有权决定自己的身体和人生，不应该被社会的道德标准所绑架。这些言论在当时的日本社会是具有相当冲击力的。

在性别平等方面，饭岛爱用自己的职业经历揭示了日本社会存在的双重标准——男性在性产业中的角色往往被忽视，而女性却要承受全部的道德指责。她直言不讳地指出："如果这个社会真的关心道德，请对男女一视同仁。"

在性教育方面，饭岛爱多次呼吁日本社会改善青少年性教育的现状。她认为，正是因为性教育的缺失，才导致了大量青少年在无知中做出伤害自己的决定。她的自传《柏拉图式性爱》在很大程度上也成为了一本另类的"性教育读本"。

时至今日，饭岛爱的这些观点仍然在日本的女性权益讨论中被频繁引用。她虽然已经离去，但她播下的种子，正在日本社会缓慢但坚定地生长。`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20art%20representation%20of%20female%20empowerment%2C%20elegant%20silhouettes%20in%20warm%20rose%20and%20cream%20tones%2C%20soft%20gradient%20background%2C%20minimalist%20composition%2C%20artistic%20and%20powerful&width=800&height=500&seq=iijima-women-01&orientation=landscape',
    date: '2024-01-05',
    author: '编辑团队',
    tags: ['饭岛爱', '女性权益', '性别平等', '社会议题'],
    featured: true,
  },
  {
    id: 6,
    title: '饭岛爱与她的综艺时代：那些年我们追过的节目',
    slug: 'variety-show-era',
    category: 'works',
    excerpt: '回顾饭岛爱参与过的经典日本综艺节目，从《笑笑也无妨！》到《伦敦之心》，她凭借真诚和机智赢得了无数观众的喜爱。',
    content: `1990年代末至2000年代，是饭岛爱在电视综艺领域的黄金时代。她参与的多档节目不仅在日本国内拥有极高收视率，在亚洲其他地区也拥有大量忠实观众。

《笑笑也无妨！》（笑っていいとも！）是富士电视台的招牌午间节目，饭岛爱作为常驻嘉宾，在节目中展现了令人惊艳的谈话能力和幽默感。主持人塔摩利曾评价她："饭岛爱是我见过的最聪明的嘉宾之一，她总能在最恰当的时机说出最恰当的话。"

《伦敦之心》（ロンドンハーツ）是朝日电视台的王牌综艺，饭岛爱在其中的表现更是令人难忘。她不怕自嘲，敢于面对节目中各种刁钻的问题和挑战，这种真诚的态度赢得了观众的心。她在节目中说过的许多金句，至今仍被日本网友津津乐道。

此外，她还参与了《男女纠察队》、《SMAP×SMAP》、《Music Station》等多个知名节目的录制。每一个节目中，她都展现出了不同的魅力——有时是知性的评论者，有时是搞笑的综艺咖，有时又是温柔的倾听者。

饭岛爱的综艺生涯证明了一个道理：真正的魅力不在于完美，而在于真实。她不掩饰自己的过去，不伪装成另一个人，正是这种真实，让她在竞争激烈的日本综艺界站稳了脚跟。`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20TV%20production%20studio%20with%20warm%20stage%20lighting%2C%20elegant%20set%20design%2C%20professional%20broadcast%20cameras%2C%20cream%20and%20gold%20color%20palette%2C%20nostalgic%20atmosphere&width=800&height=500&seq=iijima-variety-01&orientation=landscape',
    date: '2023-12-20',
    author: '编辑团队',
    tags: ['饭岛爱', '综艺节目', '日本电视', '娱乐'],
    featured: false,
  },
  {
    id: 7,
    title: '《饭岛爱白书》：未完成的绝笔',
    slug: 'iijima-white-paper',
    category: 'works',
    excerpt: '饭岛爱生前正在创作的第二本书《饭岛爱白书》未能完成便撒手人寰，但已公开的部分章节展现了她在写作上的持续成长和深刻思考。',
    content: `在《柏拉图式性爱》取得巨大成功后，饭岛爱并没有停止写作。她生前正在创作第二本重要作品——《饭岛爱白书》。

与《柏拉图式性爱》聚焦个人经历不同，《饭岛爱白书》试图从更宏观的视角探讨日本社会的问题。据已公开的部分章节显示，这本书将涵盖以下主题：日本娱乐产业的暗面、女性在职场中的生存困境、心理健康与社会偏见、以及她对生命意义的持续探索。

饭岛爱在日记中写道："如果说《柏拉图式性爱》是我对自己的和解，那么《饭岛爱白书》就是我对这个世界的提问。"

遗憾的是，这本书未能在她有生之年完成。2008年她去世后，其家人和编辑团队曾讨论是否将已完成的章节整理出版，但最终出于对逝者的尊重而选择了搁置。

然而，《饭岛爱白书》未完成的手稿已经成为日本文学研究者关注的对象。多位学者认为，从已公开的片段来看，饭岛爱在写作上的成熟度已经远超《柏拉图式性爱》时期，她正在成长为一个真正意义上的作家。

这本未完成的书，成为了饭岛爱传奇人生中又一个令人唏嘘的注脚。`,
    image: 'https://readdy.ai/api/search-image?query=Unfinished%20manuscript%20pages%20on%20a%20wooden%20desk%2C%20fountain%20pen%20resting%2C%20soft%20warm%20side%20lighting%2C%20elegant%20minimalist%20composition%2C%20cream%20and%20gold%20tones%2C%20literary%20atmosphere&width=800&height=500&seq=iijima-paper-01&orientation=landscape',
    date: '2023-12-10',
    author: '编辑团队',
    tags: ['饭岛爱', '饭岛爱白书', '未完成作品', '文学'],
    featured: false,
  },
  {
    id: 8,
    title: '日本媒体眼中的饭岛爱：从争议到尊重',
    slug: 'media-perspective',
    category: 'media',
    excerpt: '回顾日本主流媒体对饭岛爱报道态度的变迁——从早期的猎奇与争议，到后期的理解与尊重，折射出日本社会观念的演变。',
    content: `饭岛爱与日本媒体的关系，经历了从尖锐对立到相互理解的复杂过程。

在她职业生涯的早期，日本媒体对她的报道主要集中在她的AV经历和私人生活上，充满了猎奇和道德评判的色彩。许多八卦杂志不遗余力地挖掘她的过往，用耸动的标题吸引读者。那个时期，饭岛爱曾多次在节目中表达对媒体的抵触和愤怒。

然而，随着《柏拉图式性爱》的出版和她在综艺节目中展现的真实魅力，媒体的态度开始发生微妙的变化。越来越多的记者和评论家开始认真对待她的言论，而不仅仅是将她视为一个"话题人物"。

《朝日新闻》曾在一篇评论中写道："饭岛爱是日本社会的一面镜子。我们如何对待她，反映了我们如何对待那些不符合社会期待的人。"

2008年她去世后，日本各大媒体几乎全部以头条报道了这一消息，并为她献上了诚挚的悼念。《读卖新闻》称她为"一个时代的象征"，《每日新闻》评价她"用生命诠释了勇气的含义"。

从争议到尊重，媒体对饭岛爱态度的转变，也折射出日本社会观念的进步。`,
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20elegant%20Japanese%20newspapers%20and%20magazines%20on%20a%20clean%20surface%2C%20soft%20natural%20light%2C%20editorial%20atmosphere%2C%20cream%20and%20warm%20gray%20tones%2C%20minimalist%20composition&width=800&height=500&seq=iijima-media-01&orientation=landscape',
    date: '2023-11-25',
    author: '编辑团队',
    tags: ['饭岛爱', '日本媒体', '媒体报道', '社会观念'],
    featured: false,
  },
  {
    id: 9,
    title: '粉丝来信：饭岛爱如何改变了我的生活',
    slug: 'fan-letters',
    category: 'memorial',
    excerpt: '来自日本和亚洲各地的粉丝分享了饭岛爱对他们生活的深刻影响——有人因为她走出了抑郁，有人因为她找到了面对困境的勇气。',
    content: `饭岛爱离世多年后，她的影响力依然在无数粉丝的生活中延续。我们收集了一些来自粉丝的真实信件，这些文字见证了饭岛爱如何改变了普通人的生活。

来自东京的Yuki写道："我在高中时遭受了严重的欺凌，每天都在想如何结束自己的生命。直到我读了《柏拉图式性爱》，看到饭岛爱也经历过同样的事情，却依然坚强地活了下来。她让我相信，我也可以。"

来自大阪的Kenji分享道："作为一个男性，我以前对AV女优有着很多偏见。但饭岛爱在电视节目中的表现彻底改变了我的看法。她的智慧和幽默让我意识到，不能用职业来定义一个人的价值。"

来自台北的Mei说："饭岛爱是我见过最勇敢的女性之一。在一个对女性如此苛刻的社会里，她敢于做自己，敢于说出真相。她是我的人生导师，虽然我们从未谋面。"

来自首尔的Jisoo写道："我通过饭岛爱的故事了解了日本社会的另一面。她不仅仅是一个艺人，更是一个时代的见证者和改变者。"

这些来自不同国家、不同背景的粉丝信件，共同描绘了一个立体的饭岛爱——她不仅仅是一个娱乐人物，更是许多人生命中的灯塔。`,
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20handwritten%20letters%20and%20notes%20on%20a%20wooden%20table%2C%20warm%20sunlight%20streaming%20in%2C%20nostalgic%20and%20emotional%20atmosphere%2C%20cream%20and%20gold%20tones%2C%20intimate%20photography%20style&width=800&height=500&seq=iijima-fans-01&orientation=landscape',
    date: '2023-11-10',
    author: '编辑团队',
    tags: ['饭岛爱', '粉丝', '纪念', '影响'],
    featured: false,
  },
  {
    id: 10,
    title: '饭岛爱年表：36年人生完整回顾',
    slug: 'complete-timeline',
    category: 'life-experience',
    excerpt: '从1972年出生到2008年离世，详细梳理饭岛爱36年人生中每一个重要时刻。',
    content: `1972年10月31日——出生于日本东京都，原名大久保松惠。

1980年代初期——在东京的小学就读，成绩优秀但性格内向。据同学回忆，她是一个安静但有着敏锐观察力的孩子。

1985年——进入中学，开始遭受严重的校园欺凌。这段经历成为她日后心理创伤的重要来源。

1988年——高中时期离家出走，开始在东京独自生活。在便利店打工维持生计。

1990年——被星探发掘，以"饭岛爱"的艺名进入成人影片行业。

1992-1994年——在AV行业迅速走红，成为当时最受欢迎的AV女优之一。

1995年——开始尝试向电视综艺转型，首次在富士电视台的综艺节目中亮相。

1997年——正式宣布从AV行业引退，全力投入电视和写作事业。

1998年——成为《笑笑也无妨！》的常驻嘉宾，在主流综艺界站稳脚跟。

2000年10月——出版半自传体小说《柏拉图式性爱》，轰动日本社会，销量突破170万册。

2001年——《柏拉图式性爱》被改编为电视剧和电影。

2002-2005年——综艺事业的巅峰期，同时活跃于富士电视台、朝日电视台、日本电视台等多个平台的王牌节目中。

2006年——因健康问题减少工作量，开始专注写作《饭岛爱白书》。

2007年——在博客中坦诚自己与抑郁症的斗争，引发社会对心理健康的关注。

2008年12月24日——被发现于东京都涩谷区家中去世，年仅36岁。日本举国哀悼。

饭岛爱的36年虽然短暂，但她的影响力和留给世界的思考，将超越时间的界限。`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20timeline%20visualization%20with%20warm%20golden%20accents%20on%20cream%20background%2C%20clean%20design%2C%20chronological%20markers%2C%20Japanese%20aesthetic%2C%20artistic%20composition&width=800&height=500&seq=iijima-timeline-01&orientation=landscape',
    date: '2023-10-30',
    author: '编辑团队',
    tags: ['饭岛爱', '年表', '人生回顾', '时间线'],
    featured: true,
  },
  {
    id: 11,
    title: '饭岛爱与日本AV文化的变迁',
    slug: 'av-culture-transformation',
    category: 'social-impact',
    excerpt: '饭岛爱所处的时代正是日本AV产业从地下走向主流的转折期，她的个人经历与行业变迁紧密交织，成为观察日本社会变迁的独特窗口。',
    content: `1990年代的日本，AV产业正处于从地下走向主流的转折期。饭岛爱恰好在此时进入这个行业，她的个人经历与行业的变迁紧紧交织在一起。

在她出道之前，AV女优在日本社会几乎没有公开露面的机会，更不用说进入主流娱乐圈了。AV女优被视为"不应该被看到"的存在，她们被要求隐姓埋名，过双重生活。

饭岛爱打破了这一禁忌。她不仅不隐藏自己的身份，反而以真实的面貌出现在公众面前。她的成功为后来的AV女优开辟了道路——苍井空、吉泽明步等人能够进入主流娱乐圈，某种程度上都受益于饭岛爱打下的基础。

更重要的是，饭岛爱通过自己的经历，引发了日本社会对AV产业的公开讨论。她让人们意识到，AV女优也是人，也有自己的梦想、痛苦和尊严。她在节目中的坦诚分享，让许多日本民众第一次以同理心去理解这个行业的从业者。

饭岛爱不是AV产业的辩护者，也不是它的批判者。她只是一个用真实经历说话的人，而正是这种真实，让日本社会得以更理性地审视这个备受争议的产业。`,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20representation%20of%20Japanese%20media%20culture%20transformation%2C%20warm%20amber%20and%20cream%20gradient%2C%20artistic%20minimal%20design%2C%20evolving%20patterns%2C%20sophisticated%20atmosphere&width=800&height=500&seq=iijima-av-01&orientation=landscape',
    date: '2023-10-15',
    author: '编辑团队',
    tags: ['饭岛爱', 'AV产业', '社会变迁', '日本文化'],
    featured: false,
  },
  {
    id: 12,
    title: '怀念饭岛爱：十五年后的再思考',
    slug: 'fifteen-years-later',
    category: 'memorial',
    excerpt: '饭岛爱离世十五年后，我们重新审视她留给世界的遗产——她的勇气、她的文字、她对日本社会的影响，依然鲜活而有力。',
    content: `2023年，距离饭岛爱离世已经过去了十五年。十五年的时间足以让很多事情淡去，但饭岛爱的影响力却从未消退。

在社交媒体时代，饭岛爱的金句和影像片段在年轻一代中重新流传。许多00后、10后的日本年轻人通过YouTube和TikTok了解了饭岛爱的故事，她被新一代赋予了新的意义——一个敢于打破规则、追求自由的女性偶像。

她的《柏拉图式性爱》至今仍在日本的各大书店有售，年销量依然可观。许多大学的社会学和性别研究课程将这本书列为推荐阅读材料，因为它提供了理解1990-2000年代日本社会的重要视角。

在日本的网络论坛上，关于饭岛爱的讨论从未停止。每当有新的社会议题出现——校园欺凌、女性权益、心理健康——就有人会提到饭岛爱，提到她曾经说过的那些话。

十五年后回看，饭岛爱的伟大之处不在于她的名气或成就，而在于她的真实。在一个充满了虚伪和表演的世界里，她选择做真实的自己，哪怕这个"自己"并不完美。这种真实，穿越了时间，依然在感染着每一个接触到她故事的人。`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20garden%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20spring%20sunlight%2C%20path%20leading%20into%20distance%2C%20serene%20and%20hopeful%20atmosphere%2C%20cream%20and%20pink%20tones&width=800&height=500&seq=iijima-legacy-01&orientation=landscape',
    date: '2023-09-28',
    author: '编辑团队',
    tags: ['饭岛爱', '纪念', '十五年', '遗产'],
    featured: true,
  },
];

export const timelineEvents = [
  { year: '1972', title: '出生', description: '10月31日出生于东京都，原名大久保松惠' },
  { year: '1985', title: '中学时代', description: '进入中学后开始遭受严重的校园欺凌' },
  { year: '1988', title: '离家出走', description: '高中时期离家出走，开始在东京独自生活' },
  { year: '1990', title: '进入娱乐圈', description: '被星探发掘，以"饭岛爱"的艺名出道' },
  { year: '1995', title: '转型综艺', description: '开始尝试向电视综艺节目转型' },
  { year: '1997', title: '引退AV界', description: '正式宣布从AV行业引退，全力投入电视和写作' },
  { year: '2000', title: '出版自传', description: '出版《柏拉图式性爱》，销量突破170万册，轰动日本' },
  { year: '2001', title: '影视改编', description: '《柏拉图式性爱》被改编为电视剧和电影' },
  { year: '2002-2005', title: '综艺巅峰', description: '活跃于各大电视台王牌综艺节目' },
  { year: '2006', title: '健康下滑', description: '因健康问题减少工作量，开始写作《饭岛爱白书》' },
  { year: '2007', title: '公开抑郁', description: '在博客中坦诚与抑郁症的斗争' },
  { year: '2008', title: '离世', description: '12月24日被发现于东京家中去世，年仅36岁' },
];

export const siteInfo = {
  name: '饭岛爱纪念网',
  description: '全面回顾饭岛爱的传奇人生与永恒影响力',
  url: 'https://iijima-ai-memorial.com',
};